import { Dispatch, useState } from 'react';
import { API, catchFunction } from '../utils';
import { UseLikesTypes } from './hooks.types';
import { CommentsTypes } from './../types';

export const useLikes = ({ url, setCurrentPost, likeCommentUrl }: UseLikesTypes) => {
    const [likeLoading, setLikeLoading] = useState(false);
    const onClickLike = async () => {
        try {
            setLikeLoading(true);
            await API.post(url);
            setCurrentPost(({ isLiked, reactionCount, ...prev }) => ({
                ...prev,
                isLiked: !isLiked,
                reactionCount: isLiked ? (+reactionCount - 1).toString() : (+reactionCount + 1).toString(),
            }));
        } catch (error) {
            catchFunction(error);
        } finally {
            setLikeLoading(false);
        }
    };
    const handelLikeComment = async (
        comment: CommentsTypes,
        setCurrentComment: Dispatch<React.SetStateAction<CommentsTypes>>,
    ) => {
        try {
            setLikeLoading(true);
            await API.post(`${likeCommentUrl.p1}/${comment?.id}/${likeCommentUrl.p2}`);
            setCurrentComment(({ isLiked, reactionCount, ...prev }) => ({
                ...prev,
                isLiked: !isLiked,
                reactionCount: isLiked ? (+reactionCount - 1).toString() : (+reactionCount + 1).toString(),
            }));
        } catch (error) {
            catchFunction(error);
        } finally {
            setLikeLoading(false);
        }
    };

    return { likeLoading, onClickLike, handelLikeComment };
};
